import {useEffect, useRef} from 'react';

// A background search supersedes pending page requests without clearing the
// grid. Reopen pagination after those callbacks drain, including failed refreshes.
export default function useAssetPageRefresh({refreshVersion, loading, loadedPages, loaderRef}) {
    const appliedVersion = useRef(refreshVersion);
    useEffect(() => {
        if(loading || appliedVersion.current === refreshVersion) return;
        appliedVersion.current = refreshVersion;
        loadedPages.current = [];
        loaderRef.current?.resetloadMoreItemsCache(true);
    }, [refreshVersion, loading]);
}
